import { motion } from "framer-motion";
import { CONTACT } from "../../data/services";

export const WhatsAppButton = () => (
  <motion.a
    href={CONTACT.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-btn"
    aria-label="Chat on WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.6, type: "spring", stiffness: 200, damping: 16 }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="group fixed bottom-5 right-5 sm:bottom-8 sm:right-8 z-50 flex items-center gap-3"
  >
    <span className="hidden sm:block rounded-full bg-[#070F1E] border border-[#C5A059]/40 px-4 py-2 text-sm text-[#F4EEE3] opacity-0 translate-x-3 transition-[opacity,transform] duration-300 group-hover:opacity-100 group-hover:translate-x-0">Chat with us</span>
    <span className="relative grid h-14 w-14 place-items-center rounded-full bg-[#25D366] shadow-[0_12px_30px_-6px_rgba(37,211,102,0.6)]">
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <svg viewBox="0 0 32 32" className="relative h-7 w-7 fill-white" aria-hidden>
        <path d="M16.04 3C9.4 3 4 8.36 4 14.97c0 2.11.56 4.17 1.62 5.99L4 29l8.27-1.58a12.1 12.1 0 0 0 3.77.6C22.68 28.02 28 22.66 28 16.05 28 9.44 22.68 3 16.04 3Zm0 22.83c-1.17 0-2.32-.2-3.4-.6l-.49-.18-4.9.94.97-4.66-.2-.5a9.6 9.6 0 0 1-1.13-4.86c0-5.4 4.42-9.77 9.86-9.77 5.43 0 9.85 4.37 9.85 9.86 0 5.4-4.42 9.77-9.56 9.77Zm5.4-7.32c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.46-.88-.78-1.47-1.75-1.64-2.04-.17-.3-.02-.46.13-.6.13-.14.3-.35.44-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.6-.92-2.2-.24-.57-.49-.5-.67-.5h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.01-1.04 2.47 0 1.45 1.07 2.86 1.22 3.06.15.2 2.1 3.2 5.08 4.48.71.31 1.27.49 1.7.63.71.22 1.36.19 1.88.12.57-.09 1.75-.71 2-1.4.25-.69.25-1.28.17-1.4-.07-.13-.27-.2-.57-.35Z" />
      </svg>
    </span>
  </motion.a>
);
